import React from "react";
import { useLocale, useTranslations } from "next-intl";
import classNames from "classnames";

import { ButtonPrimitive } from "ui/button/button-primitive";
import { NewIcon } from "ui/NewIcon";
import { getLocationInfo } from "utils/getLocationInfo";

import css from "./club-toggle.module.scss";

interface Props {
  isClub: boolean;
  onClubToggle(isClub: boolean): void;
  darkMode?: boolean;
}

export function ClubToggle({ isClub, onClubToggle, darkMode }: Props) {
  const t = useTranslations();
  const locale = useLocale();

  const {
    features: { club },
  } = getLocationInfo(locale);

  if (!club) return null;

  return (
    <div className={classNames(css.container, { [css.container__club]: isClub, [css.container__dark]: darkMode })}>
      <ButtonPrimitive
        className={classNames(css.button, {
          [css.button__active]: !isClub,
          [css.button__dark]: darkMode,
          [css.button__activeDark]: !isClub && darkMode,
        })}
        onClick={() => (isClub ? onClubToggle(false) : null)}
      >
        {t("catalog.club_toggle.all")}
      </ButtonPrimitive>
      <ButtonPrimitive
        className={classNames(css.button, { [css.button__active]: isClub, [css.button__dark]: darkMode })}
        onClick={() => (!isClub ? onClubToggle(true) : null)}
      >
        <NewIcon icon={isClub ? "logo-alt" : "logo"} className={css.clubIcon} />
        {t("catalog.club_toggle.club")}
      </ButtonPrimitive>
    </div>
  );
}
